import {
    Button,
    CircularProgress,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import { useNavigate } from "react-router";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import OrtBakiyeListEbelediyeAPI, { OrtBakiyeListEbelediyeRequest } from "../../../apis/OB/Get/OrtBakiyeListEbelediyeAPI";
import CustomTextField from "../../../components/OB/required-text-field";

const validationSchema = Yup.object({
});

const YapilandirmaIslemleri = (props: any) => {

    const [userControlPopup, setUserControlPopup] = useState(false);
    const user = SessionStorageService.getUserInfo();

    const [isLoad, setIsLoad] = useState(true);
    const navigate = useNavigate();

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupbasvuruMetni, setPopupbasvuruMetni] = useState("");
    const [kayitBasarili, setKayitBasarili] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>('');

    interface YapilandirmaTuruOption {
        yapilandirmaTuru: string;
        sicilKodu: number;
        aboneNo: number;
        rowId: number;
        gelirAciklamasi: string;
    }

    const [yapilandirmaTurleri, setYapilandirmaTurleri] = useState<YapilandirmaTuruOption[]>([]);

    const closePopupSonuc = () => {
        setIsPopupVisible(false);
        setPopupbasvuruMetni("");
    };

    useEffect(() => {
        if (user == null) {
            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }

    }, []);

    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    }

    // yapılandırma türü
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const user = SessionStorageService.getUserInfo();
                const sicilKodu = user?.sicilKodu;
                const response = await OrtBakiyeListEbelediyeAPI.ortBakiyeListEbelediye({
                    sicilKodu: sicilKodu

                });
                console.log("response", response);
                const rawList = response.data ?? [];
                const list = rawList.map((o: any) => ({
                    yapilandirmaTuru: o.gelirAciklamasi,
                    sicilKodu: o.sicilKodu,
                    aboneNo: o.aboneNo,
                    rowId: o.rowId,              // DB’den dönen ID alanınızın ismi neyse o
                    gelirAciklamasi: o.gelirAciklamasi, // menüde göstermek istediğiniz metin
                }));
                setYapilandirmaTurleri(list);
            } catch (err) {
                console.error(err);
                setMessage("Yapılandırma türleri alınırken hata oluştu.");
                setYapilandirmaTurleri([]);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    return (
        isLoad ? <>
            <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
            {userControlPopup ? (

                <AciklamaAndUserControlPopup
                    open={userControlPopup}
                    handleClose={closeUserControlPopup}
                    isUserControlPopUp={true}
                    description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
                />

            ) : null}
        </> :
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                validateOnMount={true}
                initialValues={{
                    yapilandirmaTuru: "",
                    sicilKodu: '',
                    aboneNo: '',
                }}
                onSubmit={async (values: any, { resetForm }) => {

                    const transformedValues = {
                    };

                    // api çağırılacak

                }}
            >

                {(formikProps) => {

                    return (
                        <Form>
                            <div className="mb-3 d-flex justify-content-end">
                                <Button
                                    type="button"
                                    onClick={() =>
                                        formikProps.resetForm({ values: formikProps.initialValues })
                                    }
                                    color="secondary"
                                >
                                    Temizle
                                </Button>
                            </div>

                            <div className="card shadow-none border w-100 mb-4">
                                <div className="bg-white px-3 py-1 small fw-semibold">
                                    YAPILANDIRMA İŞLEMLERİ
                                </div>
                                <div className="card-body">
                                    {/* 1. Satır: Yapılandırma Türü ve Abone No */}
                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                name="yapilandirmaTuru"
                                                fullWidth
                                                select
                                                label="Yapılandırma Türü"
                                                size="small"
                                                value={formikProps.values.yapilandirmaTuru || ""}
                                                onChange={(e: any) => {
                                                    formikProps.setFieldValue("yapilandirmaTuru", e.target.value);
                                                }}
                                            >
                                                <MenuItem value="">
                                                    {"Seçiniz.."}
                                                </MenuItem>
                                                {yapilandirmaTurleri.map((option) => (
                                                    <MenuItem key={option.rowId} value={option.rowId}>
                                                        {option.gelirAciklamasi}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </div>
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                label="Abone No"
                                                name="aboneNo"
                                                fullWidth
                                                size="small"
                                                value={formikProps.values.aboneNo || ''}
                                                variant="outlined"
                                                type="number"
                                            />
                                        </div>
                                    </div>
                                    {/* 2. Satır: Sicil Kodu ve Ad Soyad/Unvan */}
                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                label="Sicil Kodu"
                                                name="sicilKodu"
                                                fullWidth
                                                size="small"
                                                value={formikProps.values.sicilKodu || ''}
                                                variant="outlined"
                                                disabled
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                label="Ad Soyad/Unvan"
                                                name="adSoyad"
                                                fullWidth
                                                size="small"
                                                value={formikProps.values.adSoyad || ''}
                                                variant="outlined"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    {/* 3. Satır: İşlem Tarihi ve Vade Başlama Tarihi */}
                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                label="İşlem Tarihi"
                                                name="islemTarihi"
                                                fullWidth
                                                size="small"
                                                value={formikProps.values.islemTarihi || ''}
                                                variant="outlined"
                                                disabled
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <TextField
                                                label="Vade Başlama Tarihi"
                                                name="vadeBaslamaTarihi"
                                                fullWidth
                                                size="small"
                                                value={formikProps.values.vadeBaslamaTarihi || ''}
                                                variant="outlined"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 mb-3 align-items-center">
                                <div className="col-12 col-md-8">
                                    <div className="fw-bold">GÜNCEL BORCUNUZ</div>
                                    <div className="small">Taksit işlemek için seçim yapınız 'Taksit Seçenekleri' tuşuna basınız.</div>
                                </div>
                                <div className="col-12 col-md-4 d-flex justify-content-end align-items-center gap-2">
                                    <Button variant="outlined" type="button">Taksit Seçenekleri</Button>
                                    <Button
                                        type="button"
                                        color="secondary"
                                        variant="outlined"
                                        onClick={() => navigate(-1)}
                                    >
                                        Çıkış
                                    </Button>
                                </div>
                            </div>

                            {isPopupVisible ? (
                                <BilgilendirmePopup
                                    basvuruTuruId={formikProps.values.basvuruTuruId}
                                    isSorunBildirPopup={!kayitBasarili}
                                    closePopup={closePopupSonuc}
                                    open={isPopupVisible}
                                    editDescription={popupbasvuruMetni}
                                />
                            ) : null}


                        </Form>
                    );
                }}
            </Formik>

    );
};
export default YapilandirmaIslemleri;
